/**
 * @generated SignedSource<<884deb7e0078ca12ed25a4e9b58384ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CommonQuery_getScriptsQuery$variables = {};
export type CommonQuery_getScriptsQuery$data = {
  readonly getScripts: ReadonlyArray<{
    readonly fileName: string;
    readonly url: string;
  }>;
};
export type CommonQuery_getScriptsQuery = {
  response: CommonQuery_getScriptsQuery$data;
  variables: CommonQuery_getScriptsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GetFilesOutputObjectType",
    "kind": "LinkedField",
    "name": "getScripts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommonQuery_getScriptsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CommonQuery_getScriptsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8f8553fd6f3fd6ad6e074f4a96ccb19b",
    "id": null,
    "metadata": {},
    "name": "CommonQuery_getScriptsQuery",
    "operationKind": "query",
    "text": "query CommonQuery_getScriptsQuery {\n  getScripts {\n    fileName\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5add58f7e1fcfb298985027f2bf4577";

export default node;
